import effectManager from '../module/effect';
import Param from '../param';

let effect;
const param = new Param();

export default class catalogManager {
    constructor() {

        effect = new effectManager();

        this.header = document.getElementById("l-header");
        // kv
        this.kv = document.getElementById("p-kv");
        this.kvCopyEn = document.querySelector("#p-kv-copy .en");
        this.kvCopyJp = document.querySelectorAll("#p-kv-copy .jp img");
        this.kvPhoto = document.getElementById("p-kv-photo");
        this.kvBg = document.getElementById("p-kv-bg");
        this.kvGround = document.getElementById("p-kv-ground");
        this.scrollDown = document.getElementById("scroll_down");
        this.scrollArrow = document.querySelector("#scroll_down .arrow");
        this.missionPos = '';
        this.mijPos = '';
        this.interviewPos = '';
        this.voicePos = '';

        this.mission = document.getElementById('p-ourmission');
        this.mij = document.getElementById('p-madeinjapan');
        this.interview = document.getElementById('p-specialinterview');
        this.voice = document.getElementById('p-ownersvoice');

        this.headerH = document.getElementById('l-header').clientHeight;

        if(param.browserType === 'IE'){
            TweenMax.set(this.kvCopyEn, {scale: 1});
            TweenMax.set(this.kvPhoto, {scale: 1});
        } else {
            TweenMax.set(this.kvCopyEn, {scale: 1.09});
            TweenMax.set(this.kvPhoto, {scale: 1.03});
        }
        TweenMax.set([this.header,this.kvCopyEn, this.kvCopyJp, this.kvPhoto, this.kvGround, this.scrollDown], {opacity: 0});


    }

    init() {


        this.scroll();

    }

    splash() {

        if(param.browserType === 'IE'){
            TweenMax.to(this.kvCopyJp, 1.2, {
                opacity: 1,
                ease: "Power1.easeOut"
            });
            TweenMax.to(this.kvCopyEn, 3.2, {
                delay: 0.2,
                opacity: 1,
                ease: "Power2.easeOut"
            });
            TweenMax.to(this.kvGround, 1.4, {
                delay: 0.7,
                opacity: 1,
                ease: "Power2.easeIn",
                onStart: () => {
                    TweenMax.to([this.header,this.kvPhoto], 1.2, {
                        delay: 1,
                        opacity: 1,
                        ease: "Power2.easeOut",
                        onStart: () => {
                            TweenMax.to(this.scrollDown, .9, {
                                delay: 1.5,
                                opacity: 1,
                                ease: "Power2.easeOut"
                            });
                        }
                    });
                }
            });
        } else {
            TweenMax.staggerTo(this.kvCopyJp, 1.2, {
                opacity: 1,
                scale: 1,
                ease: "Power1.easeOut"
            }, 0.08);
            TweenMax.to(this.kvCopyEn, 3.2, {
                delay: 0.2,
                opacity: 1,
                ease: "Power2.easeOut"
            });
            TweenMax.to(this.kvCopyEn, 6.2, {
                scale: 1,
                ease: "Power2.easeOut"
            });
            TweenMax.to(this.kvGround, 1.4, {
                delay: 0.7,
                opacity: 1,
                ease: "Power2.easeIn",
                onStart: () => {
                    TweenMax.to([this.header,this.kvPhoto], 1.2, {
                        delay: 1,
                        opacity: 1,
                        scale: 1,
                        ease: "Power2.easeOut",
                        onStart: () => {
                            TweenMax.to(this.scrollDown, .9, {
                                delay: 1.5,
                                opacity: 1,
                                ease: "Power2.easeOut"
                            });
                        }
                    });
                }
            });
        }

    }

    scroll() {

        let _this = this;

        TweenMax.to(this.scrollArrow, 0.6, {
            opacity: 0,
            y: '15px',
            ease: "Sine.easeOut",
            onComplete: () => {
                TweenMax.set(_this.scrollArrow, {y: '-10px'});
                TweenMax.to(_this.scrollArrow, 0.6, {
                    delay: 0.3,
                    opacity: 1,
                    y: 0,
                    ease: "Sine.easeOut",
                    onComplete: () => {
                        _this.scroll();
                    }
                });
            }
        });

    }

    resize() {
        this.missionPos = this.mission.getBoundingClientRect().top - this.headerH;
        this.mijPos = this.mij.getBoundingClientRect().top - this.headerH;
        this.interviewPos = this.interview.getBoundingClientRect().top - this.headerH;
        this.voicePos = this.voice.getBoundingClientRect().top - this.headerH;

    }

}